import React from 'react';
import '../css/Presentation.css';

const PersonalPresentation = () => {
  return (
    <section className="Headline">
      <h3 className='greeting'>
        <div className="big-title2">Hey There!</div>
        <div className="big-title">I'm Jorge Camargo</div>
      </h3>
      <h2 className="Supportingtext">Web Developer</h2>
      <p className="Simpletext">
        A seasoned Software Developer with a strong track record. 6+ years of experience, specializing in technologies like Ruby on Rails, JavaScript, React,  Database design and more. Explore my portfolio and let's chat about how I can bring your project to life!
      </p>
    </section>
  );
};

export default PersonalPresentation;
